const api = '/user-service/api/external';
export const workingHoursContext = {
  daysOfWeek: `${api}/sellerWorkingDaysOfWeek`,
  workingCalendarDays: `${api}/sellerWorkingCalendarDays`,
};
